export const ROUTES = {
    HOME: "Home",
    PRODUCTS: 'Products',
    PRODUCT_DETAILS: 'ProductDetails',
    SERVICES: 'Services',
    SERVICE_DETAILS: 'ServiceDetails',
    INSTALLED_PROJECTS: 'InstalledProjects',
    ABOUT_US: 'AboutUs',
};